import { createElement, FC, useMemo } from "react";
import { Box, Button, ButtonProps, SvgIconProps } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

interface TextIconButtonProps extends ButtonProps {
  text: string;
  icon: SvgIconComponent;
  iconLeft?: boolean;
  iconProps?: SvgIconProps;
}

const TextIconButton: FC<TextIconButtonProps> = ({
  text,
  icon,
  iconProps,
  iconLeft = false,
  size = "medium",
  ...buttonProps
}) => {
  const iconFontSize =
    iconProps?.fontSize ??
    (size === "large" ? "medium" : "small");
  const iconComponent = useMemo(() => {
    return createElement(icon, { ...iconProps, fontSize: iconFontSize });
  }, [icon, iconProps, iconFontSize]);

  return (
    <Button
      {...buttonProps}
      size={size}
      sx={{
        display: "flex",
        gap: "6px",
        flexDirection: iconLeft ? "row-reverse" : "row",
        alignItems: "center",
      }}
    >
      {/* Inherit Button theme typography (e.g. portal large CTA font) */}
      <Box
        component="span"
        sx={{
          fontSize: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          letterSpacing: "inherit",
        }}
      >
        {text}
      </Box>
      {iconComponent}
    </Button>
  );
};

export default TextIconButton;
